var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.5C16.5 1.89782 16.658 2.27936 16.9393 2.56066C17.2206 2.84197 17.6022 3 18 3L30 3C30.3978 3 30.7794 2.84197 31.0607 2.56066C31.342 2.27936 31.5 1.89782 31.5 1.5C31.5 1.10217 31.342 0.720643 31.0607 0.439338C30.7794 0.158033 30.3978 -6.07493e-07 30 -5.90104e-07L18 -6.55671e-08C17.6022 -4.81776e-08 17.2206 0.158034 16.9393 0.439339C16.658 0.720643 16.5 1.10218 16.5 1.5Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5L9 39C9.00494 40.192 9.48063 41.3337 10.3235 42.1765C11.1663 43.0194 12.308 43.4951 13.5 43.5L34.5 43.5C35.692 43.4951 36.8337 43.0194 37.6765 42.1765C38.5194 41.3337 38.9951 40.192 39 39L39 10.5C38.9951 9.30805 38.5194 8.16633 37.6765 7.32348C36.8337 6.48063 35.692 6.00494 34.5 6.00001L13.5 6.00001C12.308 6.00494 11.1663 6.48063 10.3235 7.32348C9.48063 8.16633 9.00493 9.30805 9 10.5ZM34.5 8.25001C34.8978 8.25001 35.7187 8.7187 36 9.00001C36.2813 9.28131 36.75 10.1022 36.75 10.5L36.75 39C36.75 39.3978 36.2813 40.2187 36 40.5C35.7187 40.7813 34.8978 41.25 34.5 41.25L13.5 41.25C13.1022 41.25 12.2813 40.7813 12 40.5C11.7187 40.2187 11.25 39.3978 11.25 39L11.25 10.5C11.25 10.1022 11.7187 9.28131 12 9.00001C12.2813 8.7187 13.1022 8.25001 13.5 8.25001L34.5 8.25001Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 34.125L15 36.375C15 36.9963 15.6716 37.5 16.5 37.5L31.5 37.5C32.3284 37.5 33 36.9963 33 36.375L33 34.125C33 33.5037 32.3284 33 31.5 33L16.5 33C15.6716 33 15 33.5037 15 34.125Z",
    fill: "#FFA0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIcon);
export default __webpack_public_path__ + "static/media/EmptyIcon.aa4b2a5a25a290aafa1158fec7cc3bd8.svg";
export { ForwardRef as ReactComponent };